import { useEffect } from "react";
import ReactGA from "react-ga4";
import { connect } from "react-redux";
import documentOperations from "../documents/ducks/operations";
import searchOperations from "../search/ducks/operations";
import AuditSearch from "./AuditSearch";
import { ROLES, SCOPES, audit_tabs } from "./constants";
import operations from "./ducks/operations";
import PermissionsGate from "./permissions/PermissionsGate";

const AuditSearchContainer = (props) => {
    const { handleInitialTab, loadApprovedComps, role } = props;

    useEffect(() => {
        const { auditorSearch, auditorList } = audit_tabs;
        const { auditor } = ROLES;
        role === auditor ? handleInitialTab(auditorList) : handleInitialTab(auditorSearch);
        loadApprovedComps();
        ReactGA.send({ hitType: "pageview", page: "/audit", title: "Audit" });
    }, []);

    return (
        <PermissionsGate scopes={[SCOPES.canViewAudit]}>
            <AuditSearch {...props} />
        </PermissionsGate>
    );
};

const mapStateToProps = (state) => {
    return {
        profile: state.authReducer.userProfile,
        role: state.authReducer.userProfile.role,
        searchCriteria: state.searchReducer.AUDIT.searchCriteria,
        loadedSearchCrumbs: state.searchReducer.loadedSearchCrumbs.AUDIT,
        searchResponse: state.searchReducer.AUDIT.searchResponse,
        activeTab: state.auditReducer.activeTab,
        activeHeader: state.auditReducer.activeHeader,
        isLoading: state.utilsReducer.isLoading,
        searchCleared: state.searchReducer.AUDIT.searchCleared,
        comps: state.auditReducer.comps,
        loadingSearch: state.searchReducer.loadingSearch,
        searchRun: state.searchReducer.AUDIT.searchRun,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        updateFilter: (field, value) => {
            dispatch(searchOperations.updateFilter(field, value, "AUDIT"));
        },
        handleDeleteCrumb: (criteria, value) => {
            dispatch(searchOperations.deleteCrumb(criteria, value, "AUDIT"));
        },
        clearFilters: () => {
            dispatch(searchOperations.clearFilters("AUDIT"));
        },
        handleSearchCleared: (cleared) => {
            dispatch(searchOperations.storeSearchCleared(cleared, "AUDIT"));
            dispatch(operations.clearSearchResults());
        },
        handleSearchCompsSubmit: (searchCriteria) => {
            dispatch(operations.searchComps());
        },
        handleSort: (columnName, tab) => {
            dispatch(searchOperations.sortGridTableData(columnName, tab, "AUDIT"));
        },
        handleDragEnd: (results, auditList) => {
            dispatch(operations.handleDragEnd(results, auditList));
        },
        viewDocument: (url, document) => {
            dispatch(documentOperations.viewDocument(url, document));
        },
        handleInitialTab: (tab) => {
            dispatch(operations.handleChangeTabs(tab));
        },
        loadApprovedComps: () => {
            dispatch(operations.loadApprovedComps());
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(AuditSearchContainer);
